import React from "react";

import { Container, MainSection, Details, CardLargeText } from "basics/cards";

import ItemCardToolBar from "components/ItemCardToolBar";

import QuestIcon from "icons/entities/QuestIcon";

export default function QuestCard({
  item,
  selected,
  onSelectEditedItem,
  onSelectDeletedItem,
  onCleanItemId,
}) {
  return (
    <Container selected={selected}>
      <MainSection>
        <QuestIcon />
        <Details>
          <CardLargeText>
            {" "}
            <strong>{item.order}</strong> - {item.title}
          </CardLargeText>
        </Details>
      </MainSection>

      <ItemCardToolBar
        id={item.id}
        actived={item.actived}
        selected={selected}
        onCleanItemId={onCleanItemId}
        onSelectEditedItem={onSelectEditedItem}
        onSelectDeletedItem={onSelectDeletedItem}
      />
    </Container>
  );
}
